import { DEFAULT_DASH_LIGHTING_PACK } from './pack-default';
import { GLOW_ALL_DASH_LIGHTING_PACK } from './pack-glow-all';
import { OPAQUE_ALL_DASH_LIGHTING_PACK } from './pack-opaque-all';
import type { DashLightingPack, DashLightingPackId } from './types';

export const DASH_LIGHTING_PACKS: Record<DashLightingPackId, DashLightingPack> = {
	default: DEFAULT_DASH_LIGHTING_PACK,
	'glow-all': GLOW_ALL_DASH_LIGHTING_PACK,
	'opaque-all': OPAQUE_ALL_DASH_LIGHTING_PACK,
};

export const DASH_LIGHTING_PACK_ORDER: DashLightingPackId[] = [
	'default',
	'glow-all',
	'opaque-all',
];

export const DASH_LIGHTING_PACK_LABELS: Record<DashLightingPackId, string> = {
	default: 'Default (mixed)',
	'glow-all': 'All glow',
	'opaque-all': 'All opaque',
};

export const getDashLightingPack = (id: string | null | undefined): DashLightingPack => {
	if (id && id in DASH_LIGHTING_PACKS) {
		return DASH_LIGHTING_PACKS[id as DashLightingPackId];
	}
	return DEFAULT_DASH_LIGHTING_PACK;
};

export const cycleDashLightingPackId = (current: DashLightingPackId): DashLightingPackId => {
	const index = DASH_LIGHTING_PACK_ORDER.indexOf(current);
	const next = index < 0 ? 0 : (index + 1) % DASH_LIGHTING_PACK_ORDER.length;
	return DASH_LIGHTING_PACK_ORDER[next];
};
